import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface Props {
  className?: string
  textClassName?: string
  titleClassName?: string
  title?: string | null
  description: string
  imageSrcKey: string
  showBorder?: boolean
}

const BORDER_BASE_CLASS = 'absolute left-0 right-0 h-0.5 bg-gradient-to-r from-[#467AFF] via-[#FB0E97] to-[#FF9B05]'

export const gradientBorder = (): React.ReactElement => (
  <>
    <div className={`${BORDER_BASE_CLASS} top-0`} />
    <div className={`${BORDER_BASE_CLASS} bottom-0`} />
  </>
)

export default function GradientContainer({
  className = '',
  textClassName = '',
  titleClassName = '',
  title,
  description,
  imageSrcKey,
  showBorder = false,
}: Props): React.ReactElement {
  const { t } = useTranslation('landing')

  return (
    <div className={`relative flex flex-col justify-end items-end ${className}`}>
      {showBorder && gradientBorder()}

      {title && (
        <div className={`absolute -top-14 flex w-full justify-end text-start z-10 ${titleClassName}`}>
          <h1 className="leading-10 pt-2 text-5xl font-extrabold">{t(title)}</h1>
        </div>
      )}

      <ResponsiveImage imageClassName="absolute right-0 object-contain h-full" srcKey={imageSrcKey} />

      <p className={`flex h-full justify-end items-center text-end leading-5 z-10 ${textClassName}`}>
        {Trans({
          t,
          i18nKey: description,
          components: { b: <b /> },
        })}
      </p>
    </div>
  )
}
